var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.434 18.6665H41.9486C43.8183 18.6665 45.3333 20.1943 45.3333 22.0798V26.6325C45.3333 28.518 43.8183 30.0458 41.9486 30.0458H37.434C35.5643 30.0458 34.0493 28.518 34.0493 26.6325V22.0798C34.0493 20.1943 35.5643 18.6665 37.434 18.6665Z",
    fill: "#FF901A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0514 18.6665H26.5661C28.4358 18.6665 29.9508 20.1943 29.9508 22.0798V26.6325C29.9508 28.518 28.4358 30.0458 26.5661 30.0458H22.0514C20.1818 30.0458 18.6667 28.518 18.6667 26.6325V22.0798C18.6667 20.1943 20.1818 18.6665 22.0514 18.6665ZM22.0514 33.9539H26.5661C28.4358 33.9539 29.9508 35.4817 29.9508 37.3671V41.9199C29.9508 43.8041 28.4358 45.3332 26.5661 45.3332H22.0514C20.1818 45.3332 18.6667 43.8041 18.6667 41.9199V37.3671C18.6667 35.4817 20.1818 33.9539 22.0514 33.9539ZM41.9487 33.9539H37.4341C35.5644 33.9539 34.0494 35.4817 34.0494 37.3671V41.9199C34.0494 43.8041 35.5644 45.3332 37.4341 45.3332H41.9487C43.8184 45.3332 45.3334 43.8041 45.3334 41.9199V37.3671C45.3334 35.4817 43.8184 33.9539 41.9487 33.9539Z",
    fill: "#FF901A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG1);
export default __webpack_public_path__ + "static/media/g1.40153db75a36d934ccf5c4f5dbcd658d.svg";
export { ForwardRef as ReactComponent };